// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3gPcq","signatureButtonsRight":"ModalSign_signatureButtonsRight__2d2gu"};